import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BaseModalModule } from '../base-modal.module';
import { ShelterClusterUserModalShellService } from './shelter-cluster-user/shelter-cluster-user-modal-shell.service';
import { ShelterClusterUserModalsDataService } from './shelter-cluster-user/shelter-cluster-user-modal.data.service';
import { ShelterClusterUserModalShellComponent } from './shelter-cluster-user/shelter-cluster-user-modal-shell/shelter-cluster-user-modal-shell.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NvTooltipModule } from '../../nv-tooltip/nv-tooltip.module';
import { ListContainerModule } from '../../components/list/list-container/list-container.module';
import { BatchEditService } from '../../services/batch-edit-service/batch-edit-service';
import { PageHeaderModule } from '../../components/header/page-header/page-header.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { ShelterClusterUserPortfolioModalComponent } from './shelter-cluster-user/shelter-cluster-user-portfolio-modal/shelter-cluster-user-portfolio-modal.component';
import { ShelterPortfolioPermissionDropdownComponent } from './shelter-cluster-user/shelter-cluster-user-portfolio-modal/shelter-portfolio-permission-dropdown/shelter-portfolio-permission-dropdown.component';
import { NvFormFieldModule } from 'Src/nvps-libraries/design/nv-form-field/nv-form-field.module';
import { NvIconButtonModule } from 'Src/nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { NvIconModule } from 'Src/nvps-libraries/design/nv-icon/nv-icon.module';
import { NvTextboxModule } from 'Src/nvps-libraries/design/nv-textbox/nv-textbox.module';
import { NvNoteModule } from 'Src/nvps-libraries/design/nv-note/nv-note.module';
import { NvDropdownModule } from 'Src/nvps-libraries/design/nv-dropdown/nv-dropdown.module';
import { NvPillButtonModule } from 'Src/nvps-libraries/design/nv-pill-button/nv-pill-button.module';
import { NvButtonModule } from 'Src/nvps-libraries/design/nv-button/nv-button.module';
import { NvDropdownItemModule } from 'Src/nvps-libraries/design/nv-dropdown-item/nv-dropdown-item.module';

@NgModule({
  declarations: [
    ShelterClusterUserModalShellComponent,
    ShelterClusterUserPortfolioModalComponent,
    ShelterPortfolioPermissionDropdownComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    BaseModalModule,
    MatMenuModule,
    NvDropdownModule,
    NvDropdownItemModule,
    NvButtonModule,
    NvPillButtonModule,
    NvFormFieldModule,
    NvIconButtonModule,
    NvIconModule,
    NvTextboxModule,
    NvNoteModule,
    NvTooltipModule,
    PageHeaderModule,
    ListContainerModule,
  ],
  exports: [ShelterClusterUserModalShellComponent, ShelterClusterUserPortfolioModalComponent],
  providers: [BatchEditService, ShelterClusterUserModalsDataService, ShelterClusterUserModalShellService],
  entryComponents: [
    ShelterClusterUserModalShellComponent,
    ShelterClusterUserPortfolioModalComponent,
    ShelterPortfolioPermissionDropdownComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShelterClusterUserManagementModalModule {}
